export const LOCALES = ['en', 'ar']
export const DEFAULT_LOCALE = 'en'

export const LOCALE_HREFLANG = {
  en: 'en',
  // ar: 'ar',
}

const LOCALE_PREFIXES = ['ar']

export const LOCALE_OG = {
  en: 'en_US',
  ar: 'ar_AE',
}

export const SEO_HEAD_IDS = {
  canonical: 'seo-canonical',
  ogUrl: 'seo-og-url',
  ogLocale: 'seo-og-locale',
  ogImage: 'seo-og-image',
  ogImageWidth: 'seo-og-image-width',
  ogImageHeight: 'seo-og-image-height',
  twitterCard: 'seo-twitter-card',
  hreflang: (hrefLang) => `seo-hreflang-${hrefLang}`,
}

export function getSiteUrl(host) {
  if (!host) {
    return 'https://elemental.ae'
  }

  const normalized = host.replace(/^https?:\/\//, '').replace(/\/$/, '')
  return `https://${normalized}`
}

export function getPathnameOnly(path = '/') {
  return path.split('?')[0].split('#')[0]
}

export function getPublicPath(fallbackPath = '/') {
  if (typeof window !== 'undefined') {
    return `${window.location.pathname}${window.location.search}`
  }

  return fallbackPath
}

export function getRequestPath(req, asPath = '/') {
  if (req?.originalUrl) {
    return getPathnameOnly(req.originalUrl)
  }

  const rewritten = getPathnameOnly(asPath || req?.url || '/')

  if (req?.locale && req.locale !== DEFAULT_LOCALE) {
    return localizePath(rewritten, req.locale)
  }

  return rewritten
}

export function getLocaleFromPath(path = '/') {
  const pathname = getPathnameOnly(path)
  const segments = pathname.split('/').filter(Boolean)
  const prefix = segments[0]?.toLowerCase()

  if (prefix && LOCALES.includes(prefix) && prefix !== DEFAULT_LOCALE) {
    return prefix
  }

  // if (segments[0] === 'ar') {
  //   return 'ar'
  // }

  return DEFAULT_LOCALE
}

export function stripLocaleFromPath(path = '/') {
  const pathname = getPathnameOnly(path)
  const segments = pathname.split('/').filter(Boolean)
  const prefix = segments[0]?.toLowerCase()

  if (!prefix || prefix === DEFAULT_LOCALE) {
    return segments.length ? `/${segments.join('/')}` : '/'
  }

  // Active non-default locales: strip one leading prefix.
  if (LOCALES.includes(prefix)) {
    segments.shift()
    return segments.length ? `/${segments.join('/')}` : '/'
  }

  // Disabled locale prefixes must not leak into canonical / hreflang hrefs.
  if (LOCALE_PREFIXES.includes(prefix)) {
    while (segments.length && segments[0].toLowerCase() === prefix) {
      segments.shift()
    }
  }

  // if (segments[0] === 'ar') {
  //   segments.shift()
  // }

  return segments.length ? `/${segments.join('/')}` : '/'
}

export function localizePath(path = '/', locale = DEFAULT_LOCALE) {
  const cleanPath = stripLocaleFromPath(path)

  if (locale === DEFAULT_LOCALE) {
    return cleanPath
  }

  if (cleanPath === '/') {
    return `/${locale}`
  }

  return `/${locale}${cleanPath}`
}

export function getCanonicalUrl(path = '/', host) {
  const locale = getLocaleFromPath(path)
  const siteUrl = getSiteUrl(host)

  return `${siteUrl}${localizePath(path, locale)}`
}

export function getAlternateUrls(path = '/', host) {
  const siteUrl = getSiteUrl(host)

  // const alternates = LOCALES.map((locale) => ({
  //   hrefLang: LOCALE_HREFLANG[locale],
  //   href: `${siteUrl}${localizePath(path, locale)}`,
  // }))
  const alternates = LOCALES.map((locale) => {
    const hrefLang = LOCALE_HREFLANG[locale]
    if (!hrefLang) return null

    return {
      hrefLang,
      href: `${siteUrl}${localizePath(path, locale)}`,
    }
  }).filter(Boolean)
  if (LOCALES.length > 1) {
    alternates.push({
      hrefLang: 'x-default',
      href: `${siteUrl}${localizePath(path, DEFAULT_LOCALE)}`,
    })
  }
  // alternates.push({
  //   hrefLang: 'x-default',
  //   href: `${siteUrl}${localizePath(path, DEFAULT_LOCALE)}`,
  // })

  return alternates
}
